// Small black "chip" label used as section eyebrows (black bg, white text)
export default function Label({ children, dark = false, className = "" }) {
  const base = dark
    ? "bg-white text-[#050505]"
    : "bg-[#050505] text-white";
  return (
    <span
      className={`inline-block ${base} px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.22em] ${className}`}
    >
      {children}
    </span>
  );
}
